export default __webpack_public_path__ + "static/media/brandCulqi-white.fd674e83.svg";